import {calcDailyBudget} from 'core/DailyBudget';

export function afterRefill({budget, history}: CoreState, input: MoneyAmount): MoneyAmount {
  const newAmount = budget.initial + input;
  const newBudget = {...budget, initial: newAmount};
  const newDaily = calcDailyBudget(newBudget, history);
  return newDaily.amount;
}
